/* eslint-disable no-unused-expressions */
import React from 'react';
import { TextField, Box } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import classes from './SearchBox.module.scss';

const SearchBox = React.forwardRef(
  ({ startAdornment, endAdornment, onChange, onBlur, onFocus, ...props }, ref) => {
    const [value, setValue] = React.useState('');
    return (
      <Box className={classes.searchBox}>
        <TextField
          inputRef={ref}
          {...props}
          onFocus={onFocus}
          onBlur={(event) => {
            onBlur(event);
          }}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            if (onChange) onChange(event.target.value);
          }}
          placeholder='Search Files'
          InputProps={{
            startAdornment: startAdornment || <SearchIcon />,
            endAdornment: endAdornment || null,
          }}
        />
      </Box>
    );
  }
);

export default SearchBox;
